import { Directive, HostListener } from '@angular/core';

const OPEN_CLASS = 'ant-menu-submenu-open';

/**
 * Accordion behaviour for the side nav submenus. A single delegated click
 * listener on the host replaces the old jQuery handler, which was re-bound on
 * every change detection cycle and piled up for the lifetime of the page.
 */
@Directive({
    selector: '[sideNav]'
})
export class SideNavDirective {

    @HostListener('click', ['$event.target'])
    onClick(target: EventTarget | null): void {
        if (!(target instanceof Element)) {
            return;
        }
        const title = target.closest('a.ant-menu-submenu-title');
        if (!title || !title.closest('.side-nav-menu:not(.ant-menu-inline-collapsed)')) {
            return;
        }
        const item = title.parentElement;
        if (!item) {
            return;
        }

        if (item.classList.contains(OPEN_CLASS)) {
            item.classList.remove(OPEN_CLASS);
            return;
        }
        // Only one submenu open per level.
        Array.from(item.parentElement?.children ?? [])
            .forEach(sibling => sibling.classList.remove(OPEN_CLASS));
        item.classList.add(OPEN_CLASS);
    }
}
